import localforage from "localforage";
import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";

const SIDEBAR_COLLAPSED_STATE_KEY = "sidebar-collapsed-sections";

export const _readLocalStorageSidebarState = async (): Promise<Record<string, boolean>> => {
  try {
    const result = await localforage.getItem<Record<string, boolean>>(SIDEBAR_COLLAPSED_STATE_KEY);
    return result ?? {};
  } catch (unknownErr) {
    const err = unknownErr as Error;
    logger.warn({
      message: "[_readLocalStorageSidebarState] Failed.",
      info: {
        err: objectModule.safeErrorAsJson(err),
      },
    });
    return {};
  }
};

export const _writeLocalStorageSidebarState = async (
  state: Record<string, boolean>
): Promise<void> => {
  try {
    await localforage.setItem(SIDEBAR_COLLAPSED_STATE_KEY, state);
  } catch (unknownErr) {
    const err = unknownErr as Error;
    logger.warn({
      message: "[_writeLocalStorageSidebarState] Failed.",
      info: {
        err: objectModule.safeErrorAsJson(err),
      },
    });
  }
};
